export default __webpack_public_path__ + "static/media/radio1act.9ada25da.svg";